import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 10H20M7 15H11M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z",
		stroke: "#324051",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgCreditCard;
